import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/bullet/ai-lpr.png";
import type { Product } from "../../types";
import { bullet as bulletProductListGroup } from "../product-list-groups/bullet";
import { deployment, outdoorReady } from "../properties";

export const aiLpr: Product = {
  id: "aiLpr",
  productTitle: "AI LPR",
  description: "aiLpr.description.1",
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-ai-lpr`],
  storePathParts: {
    productSlug: "uvc-ai-lpr",
    category: "cameras-bullet",
  },
  image: { src: image, width: 200, height: 140 },
  productListGroup: bulletProductListGroup,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '130 x 151.4 x 302.9 mm\n(5.1 x 6 x 11.9")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: '1/1.8" 8MP' },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "aiLpr.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: {
        type: "translation",
        value: "aiLpr.nightVision",
      },
    },
    {
      propertyId: "opticalZoom",
      value: {
        type: "translation",
        value: "aiLpr.opticalZoom",
      },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: {
        type: "boolean",
        value: true,
      },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "cameraAudio",
      value: {
        type: "translation",
        value: "commons.cameraAudio.microphone",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE+" },
    },
  ],
};
